import { ADD_NEW_VIEW_TAB_TYPE } from "../../../../../constants/stringLiterals";
import { ModalId } from "../../../../../enums/modalId";
import { setOpenedModalId } from "../../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../../redux/store/store";

/**
 * Opens the Add New View Tab modal for creating a new GI configuration.
 *
 * Dispatches a Redux action to open the modal with the "add" type,
 * which configures the modal for creating a new configuration rather than editing.
 *
 * @param {AppDispatch} dispatch - Redux dispatch function
 *
 * @example
 * const dispatch = useDispatch<AppDispatch>();
 * handleAddNewViewTab(dispatch);
 */
export const handleAddNewViewTab = (dispatch: AppDispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.ADD_NEW_VIEW_TAB,
      metaData: { type: ADD_NEW_VIEW_TAB_TYPE },
    }),
  );
};
